<template>
  <div class="page-wrapper" style="padding-top: 0">
    <div style="float: left">
      <ButtonGroup vertical>
        <Button v-for="(item,index) in typeList" :class="{'btn-primary1':type===item.value}"
                @click.stop="clickType(item.value)" :key="'keyB'+index">
          {{item.text}}
        </Button>
      </ButtonGroup>
    </div>
    <div >
      <div class=" error-color" style="padding-left: 20px; overflow: auto;text-align: center">切换tab前，请先保存当前页面资料！</div>
      <div class="content-right">
        <template v-for="(item,index) in dataListCopy" v-if="dataListCopy">
          <div class="fileItem">
            <div style="margin-bottom: 20px">
              <img v-if="item.isImg" @click.stop="showImg(item.attachmentImgUrl)" class="file-img"
                   :src="item.attachmentImgUrl" alt="">
              <img v-else class="file-img" :src="defaultImg" alt="">
              <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item,index)" v-p="{api:'projectInfo/edit'}">删除</a>
            </div>
            <Input class="input-width" v-model="item.attachmentName" placeholder="文件说明"/>
          </div>
        </template>
        <div class="fileItem">
          <Upload class="upload"
                  :action="baseUrl+'/file/uploadFile'"
                  :on-success="handleSuccess"
                  :headers="{'Access-Token':token}"
                  :show-upload-list="false"
                  :on-error="handleError"
                  v-p="{api:'projectInfo/edit'}"
          >
            <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
          </Upload>

        </div>
      </div>
    </div>
    <save-and-cancel @save="save" @cancel="cancel" v-p="{api:'projectInfo/edit'}">
    </save-and-cancel>
  </div>

</template>
<script>
  import SaveAndCancel from 'components/SaveAndCancel/index'
  import filedefault from '../../../../../assets/filedefault.jpg';
  import ImgShow from 'components/ImgShow/index'
  import {
    getProjectInfoType,
    projectInfoEdit,
    getProjectInfoByProjectIdAndType,
    removeConfigImg
  } from "../../../../../api/project";
  import {getBaseUrl, checkImgByUrl} from "../../../../../utils/public";
  import {getToken} from '@/utils/auth';
  import {deepClone} from "../../../../../utils/format";


  export default {
    name: "InfoUpdate",
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    components: {
      SaveAndCancel,
      ImgShow
    },
    watch: {
      dataList(value) {
        this.dataListCopy = deepClone(value)
      },
    },
    data() {
      return {
        target: '',
        type: '',
        dataListCopy: [],
        typeList: [],
        baseUrl: '',
        token: '',
        dataList: [],
        defaultImg: filedefault
      }
    },

    methods: {
      getProjectInfoByProjectIdAndType() {
        let params = {
          projectFid: this.projectFid,
          type: this.type
        }
        getProjectInfoByProjectIdAndType(params).then(res => {

          let list = res.data.attachmentList
          if (!list) {
            return
          }
          list.forEach(ele => {
            ele['isImg'] = checkImgByUrl(ele.attachmentImgUrl)
          })

          this.dataList = list
        })
      },
      deleteItem(item, index) {
        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            let params = {
              fid: item.fid
            }
            this.dataListCopy.splice(index, 1)
            removeConfigImg(params).then(res => {
            })
          }
        })
      },
      save() {
        var params = {
          projectFid: this.projectFid,
          attachmentList: this.dataListCopy,
          projectInfoType: this.type
        }
        projectInfoEdit(params).then(res => {
          this.$Message.success('保存成功！')
        })
      },
      cancel() {
        this.dataListCopy = deepClone(this.dataList)
      },
      handleError() {

      },
      handleSuccess(res, file) {
        // console.log(res)
        this.dataListCopy.push({
          fid: res.data.fid,
          attachmentImgUrl: res.data.url,
          isImg: checkImgByUrl(res.data.url),
          attachmentName: file.name,
          remark: ''
        })

      },
      clickType(value) {
        if (this.type == value) {
          return
        }
        // this.$Message.info('请注意先保存当前页面')
        this.dataList = []
        this.type = value
        this.getProjectInfoByProjectIdAndType()
      },

      showImg(src) {
        this.$emit('showimg', src)
      },
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()

      getProjectInfoType().then(res => {
        this.typeList = res.data.projectInfoType
        if (this.typeList.length > 0) {
          this.type = this.typeList[0].value
          this.getProjectInfoByProjectIdAndType()
        }
        // console.log(res)
      })
    }
  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 200px;
    height: 130px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 130px;
  }

  .fileItem {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    flex-wrap: wrap;

  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 200px;
  }


</style>
